import { ModalHeader } from 'reactstrap'
import styled from 'styled-components'

export const MessagesContainer = styled.div`
  max-height: 70vh;
  height: min-content;
  overflow-y: auto;

  p {
    margin: 0;
    padding: 0;
  }
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #cccccc;
  }
`
export const StyledModalHeader = styled(ModalHeader)`
  .btn-close {
    display: none;
  }
`
export const ContainerBoxMsg = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${({ type }) => (type === 'user' ? 'flex-end' : 'flex-start')};
`
export const Message = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px 20px;
  margin: 5px 0;
`

export const BotMessage = styled(Message)`
  flex-direction: row-reverse;
  color: #6f42c1;
  margin-right: 50px;
  display: flex;
  align-items: flex-end;
  gap: 5px;
  border-radius: 10px;
  font-style: italic;
  font-weight: 100;

  p {
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 10px 10px 10px 0px;
    margin: 0;
  }
  img {
    width: auto;
    height: 35px;
    background: linear-gradient(170deg, #6610f2, #6f42c1);
    padding: 5px;
    border-radius: 50%;
  }
  div {
    align-items: flex-end;
  }
`

export const UserMessage = styled(Message)`
  flex-direction: row;
  color: #fff;
  margin-left: 50px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  p {
    background: linear-gradient(170deg, #6610f2, #6f42c1);
    padding: 10px;
    border-radius: 10px 0px 10px 10px;
    margin: 0;
  }
`
export const BoxOptions = styled.div`
  margin: 5px 0 5px 30px;
`
export const BtnOption = styled.button`
  background: transparent;
  color: #007bff;
  margin: 5px;
  padding: 8px;
  text-align: left;
  border: 1px solid #007bff;
  border-radius: 10px;
  width: max-content;
  font-style: italic;
  font-weight: 100;
  transition: 0.5s;
`
export const BotMessageConfirmation = styled(Message)`
  flex-direction: row-reverse;
  color: #6f42c1;
  margin-right: 50px;
  display: flex;
  align-items: flex-end;
  gap: 5px;
  border-radius: 10px;
  font-style: italic;
  font-weight: 100;
  div {
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    background-color: #8be59ef5;
    padding: 11px;
    border-radius: 25px 25px 25px 0px;
    margin: 0;
  }
  img {
    width: auto;
    height: 35px;
    background: linear-gradient(170deg, #6610f2, #6f42c1);
    padding: 5px;
    border-radius: 50%;
  }
  div {
    align-items: flex-end;
  }
`
